import { apiFetch, httpError } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

export async function fetchJobsTable(filter) {
    const body = {
        pageNumber: filter.pageNumber ?? 1,
        pageSize: filter.pageSize ?? 20,
        sortOptions: filter.sortOptions ?? null,
        searchOptions: filter.searchOptions ?? null,
        statusFilter: filter.statusFilter ?? null,
        // Set by the ViewCustomer page's scoped Jobs table. Null = no scope.
        customerId: filter.customerId ?? null,
    };

    const res = await apiFetch(`${API_URL}/api/Job/GetJobsTable`, {
        method: 'POST',
        body: JSON.stringify(body),
    });
    if (!res.ok) throw await httpError(res, 'Failed to fetch jobs');
    return res.json();
}

// Lightweight list of every job in the tenant (excluding Cancelled), sorted
// newest-first. Used by the expense-split picker so each split row can choose
// a sibling job. No paging — per-tenant counts are small.
export async function fetchJobsDropdown() {
    const res = await apiFetch(`${API_URL}/api/Job/GetJobsDropdown`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch jobs');
    return res.json();
}

// Worker-scoped jobs list — every job the current user is explicitly
// assigned to. No paging (per-Worker counts are small) and no money
// fields, so this is the only jobs query Workers can make. Manager+
// callers will get an empty list — they should use fetchJobsTable.
export async function fetchMyAssignments() {
    const res = await apiFetch(`${API_URL}/api/JobAssignment/GetMyAssignments`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch assigned jobs');
    return res.json();
}

export async function fetchJobById(id) {
    const res = await apiFetch(`${API_URL}/api/Job/GetJobById/${id}`, { method: 'GET' });
    // Propagate 404 so ViewJobPage can render its "not found" panel.
    if (!res.ok) throw await httpError(res, 'Failed to fetch job');
    return res.json();
}

export async function updateJobStatus(id, status) {
    const res = await apiFetch(`${API_URL}/api/Job/UpdateJobStatus/${id}`, {
        method: 'POST',
        body: JSON.stringify({ status }),
    });
    if (!res.ok) throw await httpError(res, 'Failed to update job status');
    return res.json();
}
